import React from 'react'
import VerifyRiderAccountComponent from '../../components/riderregister/VerifyAccount'

const VerifyRider = (props) => {
  return (
    <div>
      <VerifyRiderAccountComponent logOut={props.logOut} />
    </div>
  )
}

export default VerifyRider
